// Set de íconos de línea, copiado verbatim de PATHS en
// context/prototype/source/star-circle-app.jsx:48-85. Primitiva compartida
// (components.md la lista como parte del sistema de diseño), replicada acá
// porque src/core es lo único común entre portal y validador.
export const ICON_PATHS: Record<string, string> = {
  star: "M12 3l2.2 5.6L20 9.2l-4.4 3.7L17 19l-5-3.2L7 19l1.4-6.1L4 9.2l5.8-.6L12 3z",
  gift: "M20 12v8H4v-8 M2 7h20v5H2zM12 7v13 M12 7S10.5 3 8 3 5 5.5 7 7m5 0s1.5-4 4-4 3 2.5 1 4",
  share: "M4 12v7a1 1 0 001 1h14a1 1 0 001-1v-7 M12 16V3 M8 7l4-4 4 4",
  invite: "M16 11a4 4 0 10-8 0 M3 21a7 7 0 0114 0 M19 8v6 M22 11h-6",
  calendar:
    "M3 9h18 M5 5h14a1 1 0 011 1v13a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1z M8 3v4 M16 3v4",
  chat: "M21 12a8 8 0 01-11.5 7.2L4 20l1-4.5A8 8 0 1121 12z",
  doc: "M14 3H7a1 1 0 00-1 1v16a1 1 0 001 1h10a1 1 0 001-1V7l-4-4z M14 3v4h4 M9 13h6 M9 17h6",
  wrench:
    "M14.5 5.5a3.5 3.5 0 00-4.6 4.3L3 16.7 7.3 21l6.9-6.9a3.5 3.5 0 004.3-4.6l-2.5 2.5-2.3-.6-.6-2.3 2.4-2.6z",
  dining: "M4 3v7a2 2 0 002 2v9 M6 3v6 M8 3v6 M16 3c-1.5 0-2 4-2 6s.8 3 2 3v9",
  car: "M5 11l1.5-4.5A2 2 0 018.4 5h7.2a2 2 0 011.9 1.5L19 11 M3 11h18v6h-2 M5 17H3v-6 M7 17h10 M6.5 14.5h.01 M17.5 14.5h.01 M7 17v2 M17 17v2",
  chevron: "M9 6l6 6-6 6",
  chevdown: "M6 9l6 6 6-6",
  check: "M5 12l4.5 4.5L19 7",
  mic: "M12 3a3 3 0 00-3 3v6a3 3 0 006 0V6a3 3 0 00-3-3z M5 11a7 7 0 0014 0 M12 18v3",
  plus: "M12 5v14 M5 12h14",
  arrow: "M5 12h14 M13 6l6 6-6 6",
  clock: "M12 7v5l3 2 M12 21a9 9 0 100-18 9 9 0 000 18z",
  pin: "M12 21s7-6.3 7-11a7 7 0 10-14 0c0 4.7 7 11 7 11z M12 10.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
  bell: "M18 8a6 6 0 10-12 0c0 7-3 8-3 8h18s-3-1-3-8 M13.7 21a2 2 0 01-3.4 0",
  sparkle:
    "M12 3v6 M12 15v6 M3 12h6 M15 12h6 M6.5 6.5l3 3 M14.5 14.5l3 3 M17.5 6.5l-3 3 M9.5 14.5l-3 3",
  medal:
    "M8.2 4l3.8 7 3.8-7 M9 13.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0z M12 4l-2-1H6l3 6 M12 4l2-1h4l-3 6",
  link: "M9 15l6-6 M10 6l1-1a4 4 0 015.7 5.7l-1 1 M14 18l-1 1A4 4 0 017.3 13.3l1-1",
  whats:
    "M12 3a8.5 8.5 0 00-7.3 12.8L3.5 21l5.4-1.2A8.5 8.5 0 1012 3z M9 8.5c.3 2.5 2.8 5 5.3 5.3.6.1 1.2-.5 1.2-1.2v-.6l-1.8-.7-.9.9c-1-.5-1.8-1.3-2.3-2.3l.9-.9-.7-1.8h-.6c-.7 0-1.3.6-1.2 1.3z",
  home: "M4 11l8-7 8 7 M6 9.5V20h12V9.5",
  doc2: "M7 3h7l4 4v14H7a1 1 0 01-1-1V4a1 1 0 011-1z M14 3v4h4",
  send: "M4 12l16-7-7 16-2-7-7-2z",
  lock: "M6 10h12a1 1 0 011 1v9a1 1 0 01-1 1H6a1 1 0 01-1-1v-9a1 1 0 011-1z M8 10V7a4 4 0 118 0v3 M12 15v2",
  qr: "M4 4h6v6H4z M14 4h6v6h-6z M4 14h6v6H4z M14 14h2v2h-2z M18 14h2v2h-2z M14 18h2v2h-2z M18 18h2v2h-2z",
  logout: "M15 17l5-5-5-5 M20 12H9 M12 4H5a1 1 0 00-1 1v14a1 1 0 001 1h7",
  store:
    "M4 9l1.4-4.3A1 1 0 016.4 4h11.2a1 1 0 011 .7L20 9 M4 9h16v10a1 1 0 01-1 1H5a1 1 0 01-1-1V9z M4 9a2.5 2.5 0 004 0 2.5 2.5 0 004 0 2.5 2.5 0 004 0 2.5 2.5 0 004 0 M9.5 20v-6h5v6",
  refresh: "M20 11a8 8 0 10-2.3 6.3 M20 5v6h-6",
  camera:
    "M4 8h3l1.5-2h7L17 8h3a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1z M12 17a4 4 0 100-8 4 4 0 000 8z",
  x: "M6 6l12 12 M18 6L6 18",
  alert: "M12 3l9.5 17H2.5L12 3z M12 10v4 M12 17.2h.01",
  wifi: "M2.5 9.5a15 15 0 0119 0 M5.5 13a10.5 10.5 0 0113 0 M8.5 16.5a6 6 0 017 0 M12 20h.01",
  // Los tres de abajo NO vienen del prototipo: el set de `star-circle-app.jsx`
  // no tiene ícono de editar, inactivar ni revertir porque el prototipo
  // resuelve esas acciones con texto. Se agregan por la revisión en vivo
  // 2026-09-22 (punto #10), dibujados con la misma gramática que el resto del
  // set: lienzo 24x24, solo trazo, sin relleno.
  // "Subir"/"Bajar" NO se agregan a propósito: se resuelven reusando
  // `chevron`/`chevdown` rotados, igual que "Volver a la app" reusa `arrow`.
  // `eye` se agrega en la fase 4b de la misma revisión: al pasar los grupos de
  // acciones de fila a ícono + tooltip, "Ver"/"Ver detalle" quedaba sin ningún
  // glifo del set que lo represente (`doc`/`doc2` significan documento, no
  // "mirar"). Misma gramática: lienzo 24x24, solo trazo, sin relleno.
  eye: "M2.5 12S6.2 5.5 12 5.5 21.5 12 21.5 12 17.8 18.5 12 18.5 2.5 12 2.5 12z M12 15a3 3 0 100-6 3 3 0 000 6z",
  edit: "M4 20h4l10-10-4-4-10 10v4z M14 6l4 4",
  deactivate: "M12 21a9 9 0 100-18 9 9 0 000 18z M5.6 5.6l12.8 12.8",
  revert: "M9 14l-5-5 5-5 M4 9h10a6 6 0 010 12h-3",
};

export type IconName = keyof typeof ICON_PATHS;
